import { Card, CardContent } from '@/components/ui/card';

export function Dashboard() {
  return (
    <Card className="w-fit">
      <CardContent className="p-6">
        <img className="h-[50vh]" src="stadium.png" />
      </CardContent>
    </Card>
  );
}
